import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { NavLink, useHistory } from 'react-router-dom';

import SVGIcon from "../svgIcon/SVGIcon";
import offeringConfigurationSlice from "../../store/offeringConfiguration/offeringConfigurationSlice";
import appStateSlice from "../../store/appState/appStateSlice";
import { ProgramSetupAxios, UserActivityAxios, OnboardingAxios } from "../../API";
import notificationSlice from "../../store/notification/notificationSlice";
import journeyMapSlice from "../../store/journeyMap/journeyMapSlice";

import authSlice from "../../store/auth/authSlice";

import { POINT_TYPE } from "../../shared/Enum";
import RouteLeavingGuard from "../../RouteGuard";
import { LeftNavigation } from "../../apiCollection";

const LeftSidebar = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const themeName = useSelector((state) => state.theme.program);
    const menuItems = useSelector((state) => state.offeringConfiguration.leftNavigation);
    const userDetails = useSelector((state) => state.auth.loggedInUser);
    const currentStage = useSelector((state) => state.appState.currentStage);
    const offeringUserId = useSelector((state) => state.auth.loggedInUser.offeringUserId);
    const isTyping = useSelector((state) => state.appState.isTyping);
    const [reVisit, setReVisit] = useState({});

    useEffect(() => {
        getLeftNavigation();
    }, []);


    const GetPoints = () => {
        OnboardingAxios.get('OfferingUsers/getuserpoints/' + userDetails.offeringUserId)
            .then(function (response) {
                let data = response.data;
                dispatch(
                    authSlice.actions.setPoints({
                        currentLevel: data.currentLevel,
                        currentRank: data.currentRank,
                        teamRank: data.teamRank,
                        pointsToNextBadge: data.pointsToNextBadge,
                        totalPoints: data.totalPoints,
                        experiencePoints: (data.points.find(x => x.pointsType == POINT_TYPE.experience) ? data.points.find(x => x.pointsType == POINT_TYPE.experience).points : 0) || 0,
                        bonusPoints: (data.points.find(x => x.pointsType == POINT_TYPE.bonus) ? data.points.find(x => x.pointsType == POINT_TYPE.bonus).points : 0) || 0,
                    })
                );
            });
    };

    const getNotifications = () => {
        UserActivityAxios.get("Notification/getnotifications/" + offeringUserId + "/1/10")
            .then(function (res) {
                dispatch(notificationSlice.actions.setNotificationList(res.data));
            })
            .catch(function (er) {
                console.log(er);
            });

    };
    const getActivityList = (id) => {
        ProgramSetupAxios.get('/OfferingStage/getstagedetailsbyofferinguser/' + id + '/' + offeringUserId)
            .then(function (response) {
                let data = response.data;
                data.sort((a, b) => parseInt(a.sequence) > parseInt(b.sequence) ? 1 : -1);
                dispatch(journeyMapSlice.actions.setStageActivities(data.activities));
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    const getLeftNavigation = () => {

        // ProgramSetupAxios.get('/OfferingConfiguration/leftnavigation/' + userDetails.offeringId + '/' + userDetails.missionId + '/' + userDetails.offeringUserId)
        LeftNavigation('/OfferingConfiguration/leftnavigation/' + userDetails.offeringId + '/' + userDetails.missionId + '/' + userDetails.offeringUserId)
            .then(function (response) {
                let data = response.data;
                dispatch(offeringConfigurationSlice.actions.setLeftNavigation(data));
                //  getProgress(data);
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    const getOfferingMission = () => {
        ProgramSetupAxios.get(
            "OfferingMission/getmissionbyid/" +
            userDetails.missionId +
            "/" +
            offeringUserId
        )
            .then(function (missionReponse) {
                dispatch(
                    authSlice.actions.setMissionDetails(missionReponse.data)
                );
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    const loadStage = (link, id, isTyping) => {
        // console.log(link, id, isTyping);
        getOfferingMission();
        if (!isTyping) {
            dispatch(appStateSlice.actions.setCurrentStage(id));
            dispatch(appStateSlice.actions.setActiveTab("Overview"));
            getNotifications();
            GetPoints();
            getLeftNavigation();
            if (id)
                getActivityList(id);
            setReVisit({});
        } else {
            setReVisit({ currentStage: id, activeTab: "Overview", link: link });
        }

        history.push(link);
    };
    const getMenuItem = (item) => {
        return <>
            <li className="menu-item-container" key={"left-main-" + item.sequence} >
                {item.action ? <NavLink to={item.action} activeClassName="active" className="menu-item" onClick={() => loadStage(0, 0, isTyping)} key={"left-nav-item-" + item.sequence}>
                    {menuTitle(item)}
                </NavLink>
                    :
                    <div className="menu-item" onClick={() => loadStage(0, 0, isTyping)} key={"left-nav-item-" + item.sequence}>
                        {menuTitle(item)}
                    </div>}
            </li>
            {item.children && item.children.length > 0 && getMenuChildItem(item.children)}
        </>;
    };

    const menuTitle = (item) => {
        return <>
            <div className="menu-item-title" key={"left-nav-icon-" + item.sequence}>
                <div className="menu-icon">
                    <SVGIcon name={themeName.toLowerCase() + `/icons/` + item.icon} />
                </div>
                <div className="menu-title">{item.name}</div>
            </div>
            <div className="menu-indicator" key={"left-nav-indicator-" + item.sequence} >
                <div className="dot"></div>
            </div>
        </>;
    };

    const getMenuChildItem = (item) => {
        let newItem = [...item];
        return <div className="scroll-content" key={"sub-menu-list" + item.sequence}>
            <ul className="sub-menu-list" >
                {newItem.map((menu, index) => {
                    let completed = menu.isComplete ? " completed" : "";
                    let isCurrent = menu.isCurrent ? " current" : "";
                    let isActive = menu.offeringStageId == currentStage ? " active" : "";
                    let isUnlocked = !menu.isUnlocked ? " locked" : " ";

                    // if not completed and not current and not unlocked
                    if (!menu.isComplete && !menu.isCurrent && menu.isUnlocked) {
                        isUnlocked = " unlocked";
                    }

                    return <li onClick={() => { menu.isUnlocked && loadStage("/mission/stage", menu.offeringStageId, isTyping); }} key={"left-child-" + index}>
                        <div className={"menu-item" + completed + isCurrent + isUnlocked + isActive} >
                            <div className={"child-connector"}>
                                <div className="indicator" />
                                <div className="indicator-line" />
                            </div>
                            <div className="menu-item-title-wrapper">
                                <div className="menu-item-title" style={{height:"38px"}}>
                                    {/* <div className="menu-icon">
                                        <SVGIcon name={themeName.toLowerCase() + `/icons/` + menu.icon} key={"menu-icon-" + item.sequence} />
                                    </div> */}
                                    <div className="menu-title">{menu.name}</div>
                                </div>
                            </div>
                        </div>
                    </li>;
                })
                }
            </ul>
        </div>;

    };

    const confirmDataLost = () => {
        dispatch(appStateSlice.actions.setIsTyping(false));
        loadStage(reVisit.link, reVisit.currentStage, false);
    };

    return (
        <>
            <RouteLeavingGuard
                when={isTyping}
                resetGuard={isTyping}
                onConfirm={() => confirmDataLost()}
                message={"You will lose content of your unsaved post. Please click Confirm to continue or Cancel to stay on this page."}
            />

            <ul className="menu-list content-height">
                {menuItems.map((item, index) => {
                    return <>
                        {getMenuItem(item)}
                        <div className="menu-item-divider" key={"menu-divider-" + index} ></div>
                    </>;
                })
                }
            </ul>

        </>

    );
};

export default LeftSidebar;